export const CONTACT = {
  email: "events@olivierboes.com",
  phone: "+34 649 671 872",
  whatsapp: "34649671872",
  instagram: "https://www.instagram.com/boesmagic/",
  instagramHandle: "@boesmagic",
  location: "Marbella, Costa del Sol",
};

// All imagery is bundled locally (in /public/images) so the site is fully
// self-contained — pure HTML/CSS/JS with no external dependency.
// Original photos sourced from olivierboes.com.
const IMG = `${process.env.PUBLIC_URL}/images`;

export const IMAGES = {
  hero: `${IMG}/hero.webp`,
  heroFull: `${IMG}/hero.webp`,
  heroAlt: "Olivier Boës performing close-up magic at a luxury wedding reception in Marbella",
  about: `${IMG}/about.webp`,
  aboutAlt: "Olivier Boës, professional magician in Marbella",
  gallery: [
    { url: `${IMG}/g1.jpg`, alt: "Wedding guests astonished during a close-up magic performance in Marbella", span: "wide", w: 1024, h: 684 },
    { url: `${IMG}/g2.jpg`, alt: "Magician throwing a playing card during a Marbella performance", span: "tall", w: 683, h: 1024 },
    { url: `${IMG}/g3.jpg`, alt: "Close-up card magic during a wedding cocktail hour in Marbella", span: "wide", w: 1024, h: 683 },
    { url: `${IMG}/g4.webp`, alt: "Olivier Boës presenting a card trick to a guest", span: "tall", w: 683, h: 1024 },
    { url: `${IMG}/g5.webp`, alt: "Bride and groom amazed by a close-up magician at their wedding", span: "wide", w: 1024, h: 682 },
    { url: `${IMG}/g6.jpg`, alt: "Guest holding the Ace of Hearts during a magic reveal", span: "tall", w: 683, h: 1024 },
  ],
};

export const VENUES = [
  "Marbella Club",
  "Puente Romano",
  "Finca Cortesin",
  "Villa Padierna",
  "The Ritz-Carlton",
  "Trocadero",
  "Finca Amalur",
];

// Real client testimonials sourced from olivierboes.com
export const TESTIMONIALS = [
  { quote: "An unforgettable wedding, made even more special thanks to Olivier's enthusiasm, professionalism, and the exceptional quality of his performance!", author: "Luna & Basilio" },
  { quote: "Olivier was incredible! Really made our cocktail hour memorable with his unbelievable talent. Our guests were astounded and were talking about him for days after.", author: "Liam & Hayley" },
  { quote: "I don't know what to highlight first. His quality as a professional or his human qualities. We started by hiring a magician and ended up gaining a friend. Absolutely TOP!", author: "Ruben & Amanda" },
  { quote: "We couldn't be happier with Olivier's work! A fantastic magician, an incredible showman, and an even better person. He left all our guests with big smiles.", author: "Daniel & Bessie" },
  { quote: "Thank you for the magic show! It was great, everyone loved it. They said it was one of the best parts of the wedding!", author: "Viktorija & Hugo" },
  { quote: "Our wedding was unforgettable. Olivier's joy and professionalism helped make this day incredible!", author: "William & Solene" },
];

export const INSTAGRAM_POSTS = [
  { url: "https://www.instagram.com/p/DYWp_DWt294/", img: `${IMG}/ig1.webp` },
  { url: "https://www.instagram.com/reel/DWjc_7yjIjA/", img: `${IMG}/ig2.webp` },
  { url: "https://www.instagram.com/reel/DV1J9l2gm8H/", img: `${IMG}/ig3.webp` },
  { url: "https://www.instagram.com/reel/DSawFsJjj_w/", img: `${IMG}/ig4.webp` },
];
